import { render, staticRenderFns } from "./PopUpImport.vue?vue&type=template&id=b10b8790&scoped=true"
import script from "./PopUpImport.vue?vue&type=script&lang=js"
export * from "./PopUpImport.vue?vue&type=script&lang=js"
import style0 from "./PopUpImport.vue?vue&type=style&index=0&id=b10b8790&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10b8790",
  null
  
)

export default component.exports